var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      { ref: "scrollView", staticClass: "clientsDetail" },
      [
        _c("div", { staticClass: "clients-information" }, [
          _c("div", { staticClass: "clients-information-header" }, [
            _c("img", {
              staticClass: "headerImg",
              attrs: {
                src: _vm.basicList.custBasicInfo.headUrl
                  ? _vm.basicList.custBasicInfo.headUrl
                  : _vm.basicList.custBasicInfo.sex == 0
                  ? require("@/assets/MM.png")
                  : require("@/assets/WW.png"),
                alt: "",
                srcset: ""
              }
            }),
            _vm._v(" "),
            _vm.basicList.custBasicInfo.member == "10"
              ? _c("img", {
                  staticClass: "vipImg",
                  attrs: { src: require("@/assets/img/v.png"), alt: "" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "information-list" }, [
              _c("div", { staticClass: "clientName" }, [
                _vm._v(
                  "\n                                   " +
                    _vm._s(_vm.basicList.custBasicInfo.custName || "") +
                    "\n                              "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "phone" }, [
                _c("img", {
                  staticClass: "phoneImg",
                  attrs: {
                    src: require("@/assets/img/phone.png"),
                    alt: "",
                    srcset: ""
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "phone-numer" }, [
                  _vm._v(_vm._s(_vm.basicList.custBasicInfo.mobile || ""))
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "telPhoneA",
                    attrs: { href: "tel:" + _vm.basicList.custBasicInfo.mobile }
                  },
                  [
                    _c("img", {
                      staticClass: "telPhone",
                      attrs: { src: require("@/assets/telPhone.png"), alt: "" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "Vip-flex" }, [
                _c("div", [_vm._v("VIP等级：")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "VIP-starts",
                    style: "width:" + _vm.VipNum * 0.4 + "rem"
                  },
                  _vm._l(_vm.VipNum, function(item, index) {
                    return _c("img", {
                      key: index,
                      staticClass: "start",
                      attrs: {
                        src: require("@/assets/img/vipStar.png"),
                        alt: "",
                        srcset: ""
                      }
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.timeM != ""
                  ? _c("div", { staticClass: "month" }, [
                      _vm._v("（" + _vm._s(_vm.timeM) + "个月）")
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "label-list" },
            _vm._l(_vm.label, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class:
                    item.edit == false ? "label-title" : "label-title-active",
                  on: {
                    click: function($event) {
                      return _vm.addLabel(item.edit)
                    }
                  }
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "clients-informationLists" }, [
          _c(
            "div",
            { staticClass: "messageList-header" },
            _vm._l(_vm.messageList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "messageList-item",
                  on: {
                    click: function($event) {
                      return _vm.showMessageList(index)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: item.edit == false ? item.img : item.imges,
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  item.code != 0
                    ? _c("div", { staticClass: "infos" }, [
                        _vm._v(_vm._s(item.code))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(item.name))])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("basicIf", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 0,
                    expression: "listIndex==0"
                  }
                ],
                ref: "basicIf",
                attrs: {
                  data: _vm.basicList,
                  custId: this.custId,
                  hasModifyAuth: _vm.hasModifyAuth
                }
              }),
              _vm._v(" "),
              _c("Inproduct", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 1,
                    expression: "listIndex==1"
                  }
                ],
                ref: "Inproduct",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("ByProduct", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 2,
                    expression: "listIndex==2"
                  }
                ],
                ref: "ByProduct",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("FwNews", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 3,
                    expression: "listIndex==3"
                  }
                ],
                ref: "FwNews",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("JnActivity", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 4,
                    expression: "listIndex==4"
                  }
                ],
                ref: "JnActivity",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("JnCurriculum", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 5,
                    expression: "listIndex==5"
                  }
                ],
                ref: "JnCurriculum",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("TheRecords", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 6,
                    expression: "listIndex==6"
                  }
                ],
                ref: "TheRecords",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("repairHis", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == 7,
                    expression: "listIndex==7"
                  }
                ],
                ref: "repairHis",
                attrs: { custId: this.custId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "basic-information" }, [
              _c("div", { staticClass: "basic-information-title" }, [
                _vm._v("最近信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "redactImg" })
            ]),
            _vm._v(" "),
            _vm.basicList.latelyInfo
              ? _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("消费门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(_vm.basicList.latelyInfo.deptName || "")
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("购买时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(_vm.basicList.latelyInfo.buyDate || ""))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("参与活动")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(_vm.basicList.latelyInfo.campName || "")
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("参与课程")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(_vm.basicList.latelyInfo.courseName || "")
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("消费金额")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.latelyInfo.amount
                                ? _vm
                                    .$numeral(_vm.basicList.latelyInfo.amount)
                                    .format("0,0.00")
                                : ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("联系日期")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.latelyInfo.followDate
                                ? _vm.basicList.latelyInfo.followDate.split(
                                    " "
                                  )[0]
                                : ""
                            )
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information" }, [
              _c("div", { staticClass: "basic-information-title" }, [
                _vm._v("系统信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "redactImg" })
            ]),
            _vm._v(" "),
            _vm.basicList.systemInfo
              ? _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("销售顾问")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.systemInfo.createUserName || ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("所属门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.systemInfo.createDeptName || ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("修改人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.systemInfo.modifyUserName || ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("修改门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.systemInfo.modifyDeptName || ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("创建时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.systemInfo.createTime
                                ? _vm.basicList.systemInfo.createTime
                                : ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("最近修改时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.basicList.systemInfo.modifyTime
                                ? _vm.basicList.systemInfo.modifyTime
                                : ""
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("群id")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(_vm.chatId))]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            model: {
              value: _vm.labelShow,
              callback: function($$v) {
                _vm.labelShow = $$v
              },
              expression: "labelShow"
            }
          },
          [
            _c("div", { staticClass: "label-models" }, [
              _c("div", { staticClass: "label-model-title" }, [
                _c("div", { staticClass: "label-model-titles" }, [
                  _vm._v("选择客户标签")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-label-hint" }, [
                  _vm._v("提示：单击选择，再次点击取消。")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "label-list-flex-itemAuto" },
                _vm._l(_vm.selectLabel, function(items, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "basic-label-title" }, [
                      _vm._v(_vm._s(items.typeName))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "label-list-flex-item" }, [
                      _c(
                        "div",
                        { staticClass: "label-list-flex" },
                        _vm._l(items.tagList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "select-labels-title",
                              style: "background:" + item.background,
                              on: {
                                click: function($event) {
                                  return _vm.clickLabels(index, item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c(
                  "div",
                  { staticClass: "button-flex-color flex-border-button" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button-flex-item",
                        on: { click: _vm.cancelLabel }
                      },
                      [_vm._v("取消")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item button-active",
                      on: { click: _vm.confirmLabel }
                    },
                    [_vm._v("确定")]
                  )
                ])
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-321b8b43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321b8b43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/clientDetails.vue
// module id = null
// module chunks = 